<mat-dialog-content>
  <h1 class="font-semibold text-2xl pb-3">
    @if (data.active) {
      Activar Diseño
    } @else {
      Desactivar Diseño
    }
  </h1>
  <div>
    @if (data.active) {
      <span>
      ¿Estás seguro que deseas volver a activar el diseño
      <span class="font-semibold">{{ data.name }}</span>?
    </span>
    } @else {
      <span>
      ¿Estás seguro que deseas desactivar el diseño
      <span class="font-semibold">{{ data.name }}</span>?
    </span>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions class="gap-2 flex flex-row">
  <button
    class="rounded-3xl flex items-center gap-2  text-white py-2 px-4 cursor-pointer"
    [ngClass]="{'bg-green-700 hover:bg-green-900': data.active, 'bg-red-600 hover:bg-red-800': !data.active}"
    (click)="delete()">
    @if (data.active) {
      <span class="text-base">Activar</span>
      <i class="fi-rr-toggle-on text-base flex"></i>
    } @else {
      <span class="text-base">Desactivar</span>
      <i class="fi-rr-toggle-off text-base flex"></i>
    }
  </button>
  <button class="rounded-3xl flex items-center gap-2 bg-gray-400 text-white py-2 px-4 cursor-pointer hover:bg-gray-600"
          (click)="close()">
    <span class="text-base">Cancelar</span>
    <i class="fi-rr-ban text-base flex"></i>
  </button>
</mat-dialog-actions>

